import { Button } from '@mui/material';
import EmptyStateBox from 'src/components/common/ui/EmptyStateBox';
import { InfoOutlined } from '@mui/icons-material';
import {
  FlexColumnContainer,
  RoundedIconContainer,
} from 'src/components/styles';
import * as Sentry from '@sentry/react';
import useAuthMutations from 'src/features/auth/presentation/hooks/useAuthMutations';
import { useEffect } from 'react';

const ErrorFallback: Sentry.FallbackRender = ({ error }) => {
  const { logoutMutation } = useAuthMutations();
  const err = error as { message?: string; name?: string };
  const isChunkError = err?.message?.includes(
    'Failed to fetch dynamically imported module'
  );

  useEffect(() => {
    if (isChunkError) {
      window.location.reload();
    }
  }, [isChunkError]);

  if (isChunkError) {
    return <></>;
  }

  const handleLogout = async () => {
    logoutMutation.mutate();
  };

  return (
    <FlexColumnContainer
      display="flex"
      justifyContent="space-between"
      alignContent="center"
      py={8}
      px={1}
      minHeight="85vh"
    >
      <EmptyStateBox
        title="Ocurrió un error"
        subtitle="Parece que algo salió mal. Por favor, intenta nuevamente."
        icon={
          <RoundedIconContainer bgcolor={({ palette }) => palette.primary.main}>
            <InfoOutlined fontSize="large" color="inherit" />
          </RoundedIconContainer>
        }
        primaryButton={
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
          >
            Reintentar
          </Button>
        }
      />
      <Button onClick={handleLogout}>Cerrar sesión</Button>
    </FlexColumnContainer>
  );
};

export default ErrorFallback;
